import React from 'react';
import type { LocaleCode } from '../Admin/I18nTripleFields';
import { SECTION_FIELD_LABELS, SECTION_FIELD_MULTILINE, type SectionFieldKey } from './sectionFieldConfig';
import type { LandingSectionLocale } from '../../i18n/localizeContent';

interface SectionI18nFieldsProps {
  active: LocaleCode;
  fields: SectionFieldKey[];
  value: LandingSectionLocale;
  onChange: (next: LandingSectionLocale) => void;
}

const SectionI18nFields: React.FC<SectionI18nFieldsProps> = ({ active, fields, value, onChange }) => {
  const patch = (field: SectionFieldKey, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{SECTION_FIELD_LABELS[field]}</label>
          {SECTION_FIELD_MULTILINE[field] ? (
            <textarea
              value={value[field] || ''}
              onChange={(e) => patch(field, e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500"
              required={active === 'pt'}
            />
          ) : (
            <input
              type="text"
              value={value[field] || ''}
              onChange={(e) => patch(field, e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500"
              required={active === 'pt'}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SectionI18nFields;
